import { IAM_CONTRACT, NON_CONTRACT, TWU_CONTRACT, WORKGROUP_MANAGER } from "./constants";
import { processRow, processHeader, downloadCSV } from "./csvUtils";

export function exportToCsv({ filename, rows, contractType, seniorityListType, station, workgroup }) {
  var csvFile = "";
  for (var i = 0; i < rows.length; i++) {
    const currentRowToProcess = scrubSeniorityRowForExport({
      seniorityRow: rows[i],
      contractType,
      seniorityListType,
      station,
      workgroup,
    });
    if (i === 0) {
      csvFile += processHeader(currentRowToProcess);
    }
    csvFile += processRow(currentRowToProcess);
  }

  downloadCSV(csvFile, filename);
}

const renderNameCell = (seniorityRow, station) => {
  let name = seniorityRow["lastName"] + ", " + seniorityRow["shortName"];

  if (seniorityRow["isTemp"] && seniorityRow["homeStation"] !== station) {
    name += " (Temp)";
  }

  return name;
};

const scrubSeniorityRowForExport = ({ seniorityRow, contractType, seniorityListType, station, workgroup }) => {
  let scrubbedSeniorityRow = {
    Rank: seniorityRow["isEmployeeEligibleForSeniorityListing"] ? seniorityRow["rank"] : "-",
    EID: seniorityRow["eid"],
    Name: renderNameCell(seniorityRow, station),
    PhoneNumber: seniorityRow["phoneNumber"] ? seniorityRow["phoneNumber"] : "-",
    "FT/PT": seniorityRow["ftpt"],
  };
  if (contractType === IAM_CONTRACT) {
    if (seniorityListType === "Classification") {
      scrubbedSeniorityRow["Classification Date"] = seniorityRow["classificationDate"];
      scrubbedSeniorityRow["Contract Date"] = seniorityRow["contractDate"];
      scrubbedSeniorityRow["Hire Date"] = seniorityRow["hireDate"];
    } else if (seniorityListType === "Contract (Vacation)") {
      scrubbedSeniorityRow["Contract Date"] = seniorityRow["contractDate"];
      scrubbedSeniorityRow["Classification Date"] = seniorityRow["classificationDate"];
      scrubbedSeniorityRow["Hire Date"] = seniorityRow["hireDate"];
    } else {
      alert("Unknown seniority list type: " + seniorityListType);
    }
  } else if (contractType === TWU_CONTRACT) {
    scrubbedSeniorityRow["WN SLI Seniority Date"] = seniorityRow["wnSliSeniorityDate"];
    scrubbedSeniorityRow["FL ATL Seniority Date"] = seniorityRow["flAtlSeniorityDate"];
    scrubbedSeniorityRow["Dual Seniority Date"] = seniorityRow["dualSeniorityDate"];
    scrubbedSeniorityRow["Hire Date"] = seniorityRow["hireDate"];
  } else if (contractType === NON_CONTRACT) {
    if (workgroup === WORKGROUP_MANAGER) {
      scrubbedSeniorityRow["Job Title"] = seniorityRow["jobTitle"];
    }
    scrubbedSeniorityRow["Seniority Date"] = seniorityRow["seniorityDate"];
    scrubbedSeniorityRow["Hire Date"] = seniorityRow["hireDate"];
  } else {
    alert("Unknown contract type: " + contractType);
  }

  return scrubbedSeniorityRow;
};
